module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-005"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_XLV"
    }
  }), _c('h1', {
    staticClass: "pre_tit"
  }, [_c('a', {
    attrs: {
      "id": "page_XLV"
    }
  }, [_c('span')]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rXLV"
    }
  }, [_vm._v("INTRODUCTION TO ROMANS 9–16")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rXLV"
    }
  }, [_vm._v("Christians have long clashed over and celebrated the first half of Romans, in which Paul addresses sin, justification, faith, grace, law and gospel.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN54",
      "id": "ap_NFIN54-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Although the latter half of Romans has not attracted the same attention, Paul provides material for significant Reformation discussion and disputes: election and predestination, the relationship between the Jews and the Gentiles in God’s salvific plan, political theology, and Christian ethics. “Saint Paul in this epistle simply wants to sum up the entire Christian, evangelical teaching,” the Lutheran pastor Cyriacus Spangenberg wrote, “and to prepare an entryway into the entire Old Testament.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN55",
      "id": "ap_NFIN55-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Accordingly the reformers will touch on an ocean of topics in this volume; however, we will only focus on four in this introduction to help light the reader’s path: predestination, the relationship between the Jews and Gentiles, the ministry of the Word, and Christian ethics.")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-012"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("On Predestination: “Before the Foundation of the World”")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Ever since Augustine’s (354–430) dispute with Pelagius (d. c. 418), the Western church has puzzled over the relationship between divine sovereignty and human freedom."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN56",
      "id": "ap_NFIN56-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" No theological debate is more charged and complex in this regard than election. Pelagius denied original sin, teaching that unaided by God’s grace human beings are able not only to will to be perfect but also to be perfect in this life. He believed that Augustine’s anthropology excused human beings for their sin and did not take seriously Jesus’ command, “Be perfect as your Father in heaven is perfect” (Mt 5:48). Augustine, in contrast, insisted on the total priority and necessity of God’s grace for human ability, willing and acting—he even conceded that a person could be sinless in this life but only by "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rXLVI"
    }
  }), _c('a', {
    attrs: {
      "id": "page_XLVI"
    }
  }, [_vm._v("God’s grace. He saw Pelagius as nullifying Jesus’ death and resurrection as well as the Holy Spirit’s work.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN57",
      "id": "ap_NFIN57-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Despite several condemnations of Pelagianism these disputes concerning the priority and necessity of God’s grace continued after the deaths of Augustine and Pelagius. At the Second Council of Orange (529), the controversy came to an end: so-called semi-Pelagianism—that human beings can reach out to God unaided and unprovoked, to which he responds with grace—was anathematized. The council fathers also anathematized “with all detestation” that God predestines some to evil—a view that could be derived from Augustine’s writings but not one that he explicitly defended."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN58",
      "id": "ap_NFIN58-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("While the reformers held a spectrum of views concerning election and predestination, all of them saw themselves as Augustine’s heirs; none of the reformers would have accepted the Pelagian label."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN59",
      "id": "ap_NFIN59-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" For the reformers, the priority and necessity of grace was nonnegotiable. Nevertheless, there is a spectrum of views among them—some monergistic (God acts alone), some synergistic (a combination of divine and human action)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN60",
      "id": "ap_NFIN60-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Double predestination.")])]), _vm._v(" Some reformers interpreted Augustine as maintaining that predestination is unconditioned by human works and choice, but that God, in his mercy and wisdom, predestines some to salvation and others to condemnation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN61",
      "id": "ap_NFIN61-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" While this “dreadful decree” causes mortals to tremble, according to these theologians, God’s word clearly teaches this."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN62",
      "id": "ap_NFIN62-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Human beings cannot plumb the inscrutable reasons God chooses to act in this way, and these reformers censored their critics accordingly. John Calvin quipped that if some take issue with this decree, “let "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rXLVII"
    }
  }), _c('a', {
    attrs: {
      "id": "page_XLVII"
    }
  }, [_vm._v("them answer why they are men rather than oxen or asses.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN63",
      "id": "ap_NFIN63-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Human beings can only marvel at the way and will of God, singing his praises and seeking refuge in his promises. John Calvin, Theodore Beza and their heirs are most well known for holding this stance. However, Martin Luther in his debate with Desiderius Erasmus also argued for this position—much to the chagrin of his students."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN64",
      "id": "ap_NFIN64-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" After this debate, Luther demurred from stating his position so explicitly; instead he pointed questioners back to the wounds and words of Christ. At table in 1532, Luther mocked the idea that God should explain himself to us: our scales are insufficient.")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("Why, if he had to answer everybody’s questions he would be a most wretched God. Let us look to the word of God and in it find refuge from the “Wherefore?” We ought to know his word, but should not inquire into his will, which is often hidden. That would be to measure wind and fire in our scales."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN65",
      "id": "ap_NFIN65-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Single predestination.")])]), _vm._v(" Other reformers found it unfitting of God’s goodness to attribute the condemnation of sinners to God’s will. They maintained that Augustine taught that God in his wisdom predestines some to salvation, while permitting others to rebel, thus condemning themselves. The "), _c('i', [_vm._v("Formula of Concord")]), _vm._v(" clearly teaches this position, saying that predestination is only a comfort for believers and that if it is taught in a way that makes people arrogant or despairing, it has been taught incorrectly."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN66",
      "id": "ap_NFIN66-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Some Reformed confessions, like the Gallic and Belgic, agree that reprobation is a function of divine permission not divine decree."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN67",
      "id": "ap_NFIN67-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Philipp Melanchthon, Jerome Bolsec (d. 1585) and Peter Martyr Vermigli also teach this position."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN68",
      "id": "ap_NFIN68-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Excursus: Erasmus and the freedom of the will.")])]), _vm._v(" Erasmus found Luther’s statements about the human will abhorrent. Particularly the theses from the Heidelberg Disputation (1518), that “free will, after the fall, exists in name only, and as long as it does what it is able to do, it commits a mortal sin. Free will, after the fall, has power to do good only in a passive capacity, but it can always do evil in an active capacity.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN69",
      "id": "ap_NFIN69-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" To Erasmus this seemed to eradicate human action and freedom, thus making God the author of sin. While asserting that ethical issues are more important than doctrinal disputes, Erasmus entered into controversy with Luther concerning the freedom of the human will. First, Erasmus defines freedom of choice ("), _c('i', [_vm._v("liberum arbitrium")]), _vm._v(") as “a power of the human will by which a man can apply himself to the things which lead to eternal salvation, or turn away from them.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN70",
      "id": "ap_NFIN70-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" Then he expounds the diverse biblical passages with the principle that human effort and divine grace are joined. “I prefer the view of those who do attribute much to free "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rXLVIII"
    }
  }), _c('a', {
    attrs: {
      "id": "page_XLVIII"
    }
  }, [_vm._v("choice, but most to grace.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN71",
      "id": "ap_NFIN71-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" In turn, Luther found Erasmus’s view abominable. He viciously attacked what he understood to be Pelagianism.")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("Your book struck me as so cheap and paltry that I feel profoundly sorry for you, defiling as you were your very elegant and ingenious style with such trash, and quite disgusted at the utterly unworthy matter that was being conveyed in such rich ornaments of eloquence, like refuse or ordure being carried in gold and silver vases."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN72",
      "id": "ap_NFIN72-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Conditional predestination. ")])]), _vm._v("In contrast to how Reformed theologians like Calvin and Beza understand God’s election—namely, an eternal immutable decree by which God freely chooses some for salvation and others for damnation—Arminians teach that predestination is conditioned by God’s foreknowledge of a person’s faith or unbelief, and that God’s grace enables and completes faith, but human beings can resist God’s grace."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN73",
      "id": "ap_NFIN73-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" “Predestination . . . is the decree of the good pleasure of God in Christ,” Jacobus Arminius states, “by which he resolved within himself from all eternity, to justify, adopt and endow with everlasting life, to the praise of his own glorious grace, believers on whom he had decreed to bestow faith.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN74",
      "id": "ap_NFIN74-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Thus Arminians affirm a form of synergism—not to be confused with works righteousness or Pelagianism—human beings cooperate with God by not resisting his grace in Christ."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN75",
      "id": "ap_NFIN75-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Those who believe in Christ will be saved; those who do not believe will be condemned."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN76",
      "id": "ap_NFIN76-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" In some respects, this understanding of predestination bears similarities to Erasmus’s views in "), _c('i', [_vm._v("Freedom of the Will.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Radicals. ")])]), _vm._v("As in most things, the radicals held diverse views concerning predestination."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN77",
      "id": "ap_NFIN77-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Still generally they tended to affirm more of a role for human free will—from something akin to Arminius’s "), _c('i', [_vm._v("not resisting grace")]), _vm._v(" (e.g., Hubmaier), to what seems more semi-Pelagian (e.g., Denck). None of them seem to have held outright Pelagian views; all sought to emphasize the importance of God’s grace. Some Italian Anabaptists, however, accepted the bondage of the will and predestination."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN78",
      "id": "ap_NFIN78-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Despite the diversity of positions on this doctrine, all the reformers sought to add predestination to the pastoral toolkit. “He [God] chose us in him [Christ] before the foundation of the "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rXLIX"
    }
  }), _c('a', {
    attrs: {
      "id": "page_XLIX"
    }
  }, [_vm._v("world, that we should be holy and blameless before him” (Eph 1:4). Of this each believer must be certain. Rather than trying to grasp at God’s hidden will, in times of trial the believer must look to Christ and say, “For me Christ was born, Christ has died, Christ has risen again.” Appealing to the inscrutable mystery of God’s providence, the reformers admonished their followers to gaze on God’s mercy in Christ. Human reason cannot grasp the hidden counsels of God. Thankfully God has condescended to us, revealing himself in Christ, the Word and the sacraments.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-013"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_XLIX"
    }
  }, [_vm._v("The Call of the Nations: “Branches Were Broken Off So That You Might Be Grafted In”")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_XLIX"
    }
  }, [_vm._v("For the reformers, Jesus Christ is the substance of Scripture. Accordingly they understood the church to be the true Israel, and in this sense Christians are true Jews. “We have been grafted into the church of Israel—she is our mother,” Wolfgang Musculus teaches. “We receive her abundance; not she ours.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN79",
      "id": "ap_NFIN79-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" They considered the patriarchs and matriarchs of Israel as their own fathers and mothers in the faith. For example, one Lutheran pastor, Justus Menius, in his commentary on 1 Samuel states that “Scripture records the saints’ weakness and sin . . . for our consolation, certainly, so that it might rouse our faith, lest we despair at the sight of our sin or some other weakness.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN80",
      "id": "ap_NFIN80-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" For Menius the communion of saints includes Old Testament believers. However, in those Jews who rejected Christ and the prophets, the reformers also saw a theology of works righteousness; thus these Jews served as a paradigm for the reformers’ opponents, who rejected justification by faith alone.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("God has granted favor and special benefits on the Israelites (Rom 9:4-5); nevertheless, “God has consigned all to disobedience, that he may have mercy on all” (Rom 11:32). According to the flesh all human beings are children of wrath; therefore, to be of the carnal seed of Abraham benefits no one. Life and blessing come with being of the spiritual seed of Abraham; this comes only by faith, itself a gift of God. And so the Lord makes a people for himself from Jews and Gentiles—a message writ large over all Scripture. Time and again the reformers repeat the biblical admonition that to be a child of God is not the result of one’s effort and merit; God’s will and wisdom accomplish this alone. So Paul places law and gospel side by side in his horticultural metaphor (Rom 11:17-24): grafted into the tree, you participate in the lifeblood of Christ—you are God’s beloved child; but God is no respecter of persons, so do not arrogate this privilege to your own merit or worth—you too could be lopped off. “Let the one who boasts, boast in the Lord” (1 Cor 1:31).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("On anti-Judaic sentiment.")])]), _vm._v(" While not all the reformers were equally vitriolic toward the Jews, almost all of them said things that are shocking today."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN81",
      "id": "ap_NFIN81-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" “The first half of the sixteenth century was above all a time of exclusion,” R. Gerald Hobbs observes."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN82",
      "id": "ap_NFIN82-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Throughout Europe Jews were ostracized if not exiled; the reformers were socialized to see Jews as “the other,” and few of the "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rL"
    }
  }), _c('a', {
    attrs: {
      "id": "page_L"
    }
  }, [_vm._v("reformers broke this mold.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN83",
      "id": "ap_NFIN83-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" In no way do we thus mean to condone their bias and bigotry toward the Jews. However, this reminds us that their time and culture must be understood in their own right, before we move to assess whether and in what way to appropriate their ideas today.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-014"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("Ministry of the Word: “Behold, I Have Put My Words in Your Mouth”")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("God chooses to work through ordinary means. The reformers regularly remind us, therefore, that God delights to work through human beings."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN84",
      "id": "ap_NFIN84-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" When the preacher speaks, God speaks—of course, only so far as he speaks in accordance with Scripture (Rom 12:6)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN85",
      "id": "ap_NFIN85-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" Luther regularly remarked that God’s Word must be spoken and heard, not merely read: “The church is a mouth house, not a pen house, for since Christ’s advent the gospel is preached orally, while before it was hidden in written books. It is the nature of the new covenant and the gospel that it is to be preached and urged orally with a living voice.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN86",
      "id": "ap_NFIN86-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" The Scriptures are alive. Believers experience this truth in prayer and preaching, for the Holy Spirit—who is not to be separated from God’s Word—stirs up readers and hearers in faith. And it is no coincidence that God works in this way. “The gospel does not fall by chance like rain from the clouds,” Calvin comments; “rather it is delivered by human hands to wherever it is sent by God.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN87",
      "id": "ap_NFIN87-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Whatever was written in former days was written for our instruction, that through endurance and through the encouragement of the Scriptures we might have hope” (Rom 15:4). The reformers oriented their approach to and use of Scripture around verses like this (also 2 Tim 3:16-17; Ps 119:105). In their preaching and teaching, they regularly reminded their congregants and students that Scripture is for them, for their correction and for their instruction.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This normative Word of God, which rules and orders the people of God, comes as law and gospel (an insight especially prevalent among Lutheran exegetes)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN88",
      "id": "ap_NFIN88-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Every Christian must learn to distinguish law from gospel. Admittedly no easy task! When a student admitted that he was struggling to distinguish law from gospel, Luther teased him: “Yes, dear master Hans, as soon as you can do that, then you will be a doctor! (And he stood up and removed his beret.) As soon as you can do that, I will say to you: ‘Dear Herr Doctor Johann, you are a learned man. Paul and I still haven’t progressed so far.’”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN89",
      "id": "ap_NFIN89-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Nevertheless, the general principle is simple enough, as Tilemann Hesshus succintly puts it: “Law consigns all to sin and unbelief; however, the gospel announces "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rLI"
    }
  }), _c('a', {
    attrs: {
      "id": "page_LI"
    }
  }, [_vm._v("God’s lovingkindness to all.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN90",
      "id": "ap_NFIN90-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" He unpacks this by saying that law and gospel are to be distinguished according to the time of their revelation, the condition of their promises and their effects. The law was revealed to Adam and Eve and written into every human heart; the gospel remained a mystery until its revelation in our Lord Jesus Christ. The law promises God’s love and favor as well as eternal life only to those who keep the whole law perfectly; the gospel promises the same things but unconditionally (“it destroys our works”). The law reveals God’s judgment, our iniquity and eternal death; the gospel frees us from sin, wrath, death, Satan’s tyranny and hell, placing us in the kingdom of light and life."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN91",
      "id": "ap_NFIN91-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Once one reads Scripture in this manner, then, according to Luther’s jest, one becomes more learned than every saint.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-015"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("Christian Ethics: “Put On the Lord Jesus Christ”")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("“Whatever does not proceed from faith is sin” (Rom 14:23). The reformers are adamant that this includes love. Unless it is conditioned and formed by faith, love goes astray, no matter how well intentioned. In Romans 12–15, according to the reformers, Paul explains his teaching concerning good works, that is, Christian love. United to Christ, believers are grafted into the Good Tree, so that they can only bear his good fruit. Just as Christ did not insist on what is his—as true God from true God—but instead “emptied himself, by taking the form of a servant,” and “humbled himself by becoming obedient to the point of death, even death on a cross” (Phil 2:7-8), so also should we empty ourselves in service to God and neighbor. Of course, this is only possible by God’s grace and Spirit, for “the love of God does not find but creates what is lovable to it,” Luther declared, but “the love of human beings comes into existence by what is lovable to it.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN92",
      "id": "ap_NFIN92-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Most of the reformers frame Paul’s doctrine in Romans 12–15 within the context of the second table of the Ten Commandments. That is, those commandments summarized by our Lord as “You shall love your neighbor as yourself” (Mt 22:39). Thus the majority of these commentators affirm the third use of the law: baptized Christians should use the law by God’s Spirit as an aid to live godly, sober and righteous lives."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN93",
      "id": "ap_NFIN93-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" The first two uses of the law are the civil use (to promote external morality even among unbelievers) and the theological use (to reveal and convict one of one’s sin). Some claimed that the third use of the law negated the grace of the gospel, which frees people of the law’s demands. Most Reformed and some Lutheran theologians, however, countered that those whom God has justified he will sanctify. And he has ordained the law for this purpose too.")]), _c('div', {
    staticClass: "stroplg"
  }, [_c('p', {
    staticClass: "verslg"
  }, [_vm._v("His delight is in the law of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(",")]), _c('p', {
    staticClass: "verslg type1"
  }, [_vm._v("   and on his law he meditates day and night. (Ps 1:2)")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rLII"
    }
  }), _c('a', {
    attrs: {
      "id": "page_LII"
    }
  }, [_c('b', [_c('i', [_vm._v("Excursus: On government.")])]), _vm._v(" That Jesus is Lord over all aspects of life the reformers assumed. How to apply this truth to politics, however, is tricky, for nearly all the reformers taught that Christians must distinguish between the spiritual and worldly kingdoms.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN94",
      "id": "ap_NFIN94-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Each realm has a form of government particular to it. In the spiritual realm before God the preaching of the Word and the administration of the sacraments promote freedom and equality; in the worldly realm before human beings law and reason preserve physical life. One must distinguish in which realm one is acting and who is the appropriate authority of that realm; thus one realm does not rule over the other. “The king could be rebuked by the priest,” David Whitford summarizes, “but the priest could also be chastised for his malfeasance by the king.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN95",
      "id": "ap_NFIN95-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Still one must act in accordance with one’s office; thus private citizens are not authorized to resist authority actively. According to the reformers, this was a key problem with the Peasants’ War; they were acting outside of their office, and thus promoting disorder. In political matters, too, the reformers stressed that God acts through the ordinary means that he has ordained for his creatures.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Within this general agreement, the reformers advocated three different postures toward secular authority: (1) a positive understanding of the magistrates with an emphasis on civil submission (e.g., Erasmus and Luther); (2) a positive understanding of the magistrates that made more room for resistance by reading Romans 13 through Acts 5 (e.g., Calvin and Beza); and (3) a negative understanding of the magistrates coupled with the claim that government is for the righteous and that Christians should withdraw from the worldly realm (e.g., Menno Simons and Michael Sattler). One other political theology rejected the consensus concerning the two kingdoms; instead a government’s legitimacy was predicated on correct Christian living, which it was sanctioned to coerce (e.g., Thomas Müntzer)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN96",
      "id": "ap_NFIN96-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Most of the reformers considered this outrageous and wrongheaded theology, and would have affirmed Luther’s sentiment in this sermon on Matthew 24:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("He says this so that the disciples wouldn’t think that Christ’s kingdom would be a worldly or physical kingdom. And it is a very necessary preface and warning which he gives his disciples here. For not only the disciples were mired in this delusion, but also the Chiliasts, Valentinians and Tertullians all fooled around with these thoughts, that before the Last Day it would happen that Christians alone would possess the earth, and that there will be no ungodly. They were moved to these thoughts because the ungodly are so fortunate in the world—they have kingdoms, worldly authority, wisdom and power—but compared to them, Christians are regarded as nothing. So they thought: “Hey, the godless will all be stamped out, so that the pious can live in peace!” . . . They have twisted these passages to mean that Christ’s kingdom would be one of worldly peace and tranquility, and some of them have tied this peace to a thousand-year period."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN97",
      "id": "ap_NFIN97-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rLIII"
    }
  }), _c('a', {
    attrs: {
      "id": "page_LIII"
    }
  }, [_vm._v("We would like to add a final note about gendered language. In keeping with the guidelines of this series we have translated terms which refer to humanity as a whole in ways that avoid masculine constructions.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN98",
      "id": "ap_NFIN98-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" At times, however, we have kept some gendered constructions, which reflect sixteenth-century culture but not necessarily contemporary views on gender issues.")]), _c('p', {
    staticClass: "sep"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/sep_autre.jpg"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As an entrée to the commentary that follows, we would like to end with Cyriacus Spangenberg’s panegyric for Romans:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In sum, this epistle is a light. It shines before the dull and the ignorant to teach them, to enlighten them and to give them correct understanding. It is a truly well-stocked apothecary and herbal bath. If someone has trials and troubles in his heart and conscience, here he will find the right "), _c('i', [_vm._v("garden angelica")]), _vm._v(", not pagan, but holy goldenrod, the true "), _c('i', [_vm._v("Angelica")]), _vm._v(" and the Holy Spirit’s root, precious living water and bread from heaven, and a compress against every kind of harm. . . .")]), _c('p', {
    staticClass: "txt_courant_justif last retrait_autre"
  }, [_vm._v("And who is able fully to laud this holy and divine writing? Yes indeed, everything is in it: spirit, life and power. And although a number of the worldly wise and scribes (like Erasmus and others) do not relish the sweetness of this epistle—and thus judge strangely concerning St. Paul’s style and skill in speech—all the same, on account of the aforementioned reasons and manifold benefit, we should seize and teach what is really presented to us in this epistle. We should follow it, let it be faithfully commended to us, diligently apply ourselves to it, ponder it with seriousness and humility. Additionally we should call on G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(" for his Spirit and live in obedience with his Spirit. God will certainly act in this way for those who are his, and will let us experience all manner of blessing through Christ Jesus our Lord. Amen."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN99",
      "id": "ap_NFIN99-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We pray that you will take up this book and read so that “together you may with one voice glorify the God and Father of our Lord Jesus Christ” (Rom 15:6).")])])]), _c('p', {
    staticClass: "sign"
  }, [_c('i', [_vm._v("Philip D. W. Krey")]), _c('br'), _c('i', [_vm._v("Peter D. S. Krey")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31094265","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre6.vue
// module id = 81
// module chunks = 0